<script setup>
  defineProps({ loading: { type: Boolean, default: false } });
</script>

<template>
  <v-overlay :model-value="loading" class="align-center justify-center">
    <v-progress-circular color="primary" indeterminate size="64" />
  </v-overlay>
</template>
